import * as React from "react";
import {
  useParams,
  useNavigate,
  useLocation,
  useMatch,
} from "react-router-dom";
import { css } from "@emotion/core";
import { Button, Card, Classes, Dialog } from "@blueprintjs/core";
import Map from "./Map";
import Annotation from "models/Annotation";
import { isSurveyArchived } from "interfaces";

const MapPane = ({ surveys, layers, orders, assets }) => {
  const [isOpen, setIsOpen] = React.useState(true);
  const params = useParams();
  const navigate = useNavigate();

  const isSurveyRoute = useMatch("/surveys/:id") !== null;

  const selectedSurveyId = (params.id && Number(params.id)) || null;
  const selectedSurvey = surveys.find(
    (survey) => survey.id === selectedSurveyId
  );

  const order = orders.filter(
    (order) => order.survey_id === selectedSurveyId
  )[0];

  const orderSubmitted =
    (order?.submitted !== undefined && order?.submitted !== null) ||
    order?.scheduled_at !== null;

  const showModal =
    isOpen &&
    selectedSurvey &&
    !isSurveyArchived(selectedSurvey) &&
    orderSubmitted === false &&
    layers.filter((layer) => layer.survey_id === selectedSurvey.id).length ===
      0 &&
    isSurveyRoute;

  const closeModal = () => setIsOpen(false);

  React.useEffect(() => {
    if (isSurveyRoute) {
      setIsOpen(true);
    }
  }, [selectedSurveyId, isSurveyRoute]);

  const annotations = Annotation.forSurvey(selectedSurveyId);

  return (
    <main
      css={css`
        position: relative;
        width: 100%;
        height: 100%;
      `}
    >
      <Dialog
        className="bp6-dark"
        isOpen={showModal}
        canEscapeKeyClose
        canOutsideClickClose
        onClose={closeModal}
        title=""
      >
        <div className={Classes.DIALOG_BODY}>
          <Card>
            <p
              css={css`
                padding-left: 1rem;
              `}
            >
              {order
                ? `Continue existing order for this survey.`
                : `Create an order for this survey.`}
            </p>
          </Card>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            {order ? (
              order.scheduled_at ? (
                <Button
                  icon="cube-remove"
                  text="Cancel Order"
                  intent="danger"
                  onClick={() => {}}
                />
              ) : (
                <Button
                  icon="cube-add"
                  text="Continue Order"
                  intent="success"
                  onClick={() => {
                    closeModal();
                    navigate(`/surveys/${params.id}/orders/${order.id}`);
                  }}
                />
              )
            ) : (
              <Button
                icon="cube-add"
                text="Create Order"
                intent="success"
                onClick={() => {
                  closeModal();
                  navigate(`/surveys/${params.id}/orders/new`);
                }}
              />
            )}
            <Button onClick={closeModal}>Dismiss</Button>
          </div>
        </div>
      </Dialog>
      <Map
        surveys={surveys}
        layers={layers}
        annotations={annotations}
        assets={assets}
      />
    </main>
  );
};

export default MapPane;
